import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import EditTopComponent from "../../CoreComponents/EditTopComponent";
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import axios from "axios";
import {
  is_shop_admin,
  is_shop_manager,
  franchise,
  branch,
  url,
  works_in_franchise,
} from "../../Functionalities/Config";

import {
  DIFFERENCE_OF_ARRAYS,
  ManageProducts,
  showMessage,
  getToken,
} from "../../Functionalities/Functions";
import { ManageInnerCategory } from "../Menu/Logic";
import { ManageSloats } from "../Sloats/Functions";

// Import modular sub-components
import ProductEditForm from "./Components/ProductEditForm";
import ProductDetailsCard from "./Components/ProductDetailsCard";
import ProductImageGallery from "./Components/ProductImageGallery";
import ProductVariantsSection from "./Components/ProductVariantsSection";
import ProductSlotsSection from "./Components/ProductSlotsSection";
import ProductMenusSection from "./Components/ProductMenusSection";

function Body() {
  const { id } = useParams();
  const [catData, setCatData] = useState([]);

  const getCategoryData = async () => {
    let params = "for_dropdown=true&is_dropdown=true&page_wise=false";
    let result = await ManageInnerCategory("", "", "get", params);
    const list = Array.isArray(result?.data)
      ? result.data
      : (Array.isArray(result?.data?.results)
          ? result.data.results
          : (Array.isArray(result?.data?.data) ? result.data.data : []));
    setCatData(list);
  };
  const [Edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tagList, settagList] = useState([]);
  const [errors, setErrors] = useState([]);
  const [sloats, setSloats] = useState([]);
  const slotsLoadedRef = useRef(false);

  const remainingList = (Array.isArray(catData) ? catData : []).filter((cat) => !tagList.includes(cat.id));

  const [data, setData] = useState({
    id: "",
    name: "",
    description: "",
    category_tag: [],
    inner_category: [],
    images: [],
    displayImage: "",
    is_blocked: false,
    is_out_of_stock: false,
    is_service: true,
    is_subscribable: false,
    service_charge: "",
    branch: "",
    varients: [],
    rating: "",
    sloats: [],
    is_new: false,
    is_popular: false,
    is_recommended: false,
    is_bundle: false,
    is_trending: false,
    occasion_tag: "",
  });

  useEffect(() => {
    getData();
    getCategoryData();
  }, []);

  useEffect(() => {
    if (errors.length > 0) {
      showMessage(
        errors[0],
        "danger",
        "This field cannot be empty",
        "top",
        "top-right",
        0
      );
    }
  }, [errors]);

  const getData = () => {
    setLoading(true);
    // Without my_branch, production hides blocked, out-of-stock and paused products
    // from restaurant logins, so their product page showed "No Product".
    let params = "my_branch=true&id=" + id + "&date=" + new Date();
    let res = ManageProducts("", "", "get", params);

    res.then((result) => {
      if (result && result.data.results.length > 0) {
        var pdt_data = result.data.results[0];
        setData({
          ...data,
          id: pdt_data.id,
          name: pdt_data.name,
          displayImage:
            pdt_data.images.length > 0 ? pdt_data.images[0].image : "",
          description: pdt_data.description,
          images: pdt_data.images,
          is_blocked: pdt_data.is_blocked,
          is_out_of_stock: pdt_data.is_out_of_stock,
          is_service: pdt_data.is_service,
          is_subscribable: pdt_data.is_subscribable,
          service_charge: pdt_data.service_charge,
          branch: pdt_data.branch,
          varients: pdt_data.varients,
          rating: pdt_data.ratings ? pdt_data.ratings : 0,
          sloats: pdt_data.sloats,
          product_commission: pdt_data?.product_commission,
          on_sale: pdt_data.on_sale,
          sale_discount: pdt_data.sale_discount ?? "",
          category_tag: pdt_data.category_tag || [],
          inner_category: pdt_data.inner_category,
          is_new: pdt_data.is_new,
          is_popular: pdt_data.is_popular,
          is_recommended: pdt_data.is_reomanded,
          is_bundle: pdt_data.is_bundle || false,
          is_trending: pdt_data.is_trending || false,
          occasion_tag: pdt_data.occasion_tag || "",
          inner_category1: pdt_data.inner_category
            ? (Array.isArray(pdt_data.inner_category)
                ? (pdt_data.inner_category.length > 0 ? pdt_data.inner_category[0].id : "")
                : pdt_data.inner_category.id)
            : "",
        });
        
        if (!slotsLoadedRef.current) {
          slotsLoadedRef.current = true;
          const branchId = pdt_data.branch && typeof pdt_data.branch === 'object' ? pdt_data.branch.id : pdt_data.branch;
          getSlots(pdt_data.sloats, branchId);
        }

        var arrayList = [];
        for (var x = 0; x < result.data.results[0].inner_category.length; x++) {
          arrayList.push(result.data.results[0].inner_category[x].id);
        }
        settagList(arrayList);
        setLoading(false);
      }
    }).catch((err) => {
      setLoading(false);
      showMessage("", "danger", "Loading error", "top", "top-right", 0);
    });
  };

  const getSlots = async (pdtSloats, bId) => {
    let params = "page_wise=0";
    let targetFranchise = null;

    if (works_in_franchise) {
      targetFranchise = franchise?.id;
    } else if (is_shop_admin || is_shop_manager) {
      targetFranchise = branch && branch.length > 0 ? (branch[0].franchise?.id || branch[0].franchise) : "";
    }

    if (!targetFranchise && bId) {
      try {
        const response = await axios.get(
          `${url}/branch/details/?id=${bId}`,
          { headers: { Authorization: getToken() } }
        );
        if (response.data && response.data.results && response.data.results.length > 0) {
          const branchObj = response.data.results[0];
          targetFranchise = branchObj.franchise && typeof branchObj.franchise === 'object'
            ? branchObj.franchise.id
            : branchObj.franchise;
        }
      } catch (error) {
        console.error("Failed to get branch franchise in getSlots:", error);
      }
    }

    if (targetFranchise) {
      params += `&franchise=${targetFranchise}`;
    }

    let result = ManageSloats("", "get", "", params);
    result
      .then((result) => {
        const slotsList = result && result.data && Array.isArray(result.data.data)
          ? result.data.data
          : (result && result.data && Array.isArray(result.data) ? result.data : []);
        const finalArray = DIFFERENCE_OF_ARRAYS(slotsList, pdtSloats || []);
        setSloats(finalArray);
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
      });
  };

  const handleSloatRemove = (slotId) => {
    let result = ManageProducts("", data, "remove_sloat", "", slotId);
    result
      .then((res) => {
        if (res.data.Status === true) {
          showMessage(
            "Sloats updated",
            "success",
            "Success!",
            "top",
            "top-right",
            0
          );
          window.location.reload();
        } else {
          showMessage(
            res.data.Error,
            "danger",
            "Error!",
            "top",
            "top-right",
            0
          );
        }
      })
      .catch((err) => err);
  };

  const handleSloatUpdate = () => {
    let result = ManageProducts("", data, "add_sloat", "");
    result
      .then((res) => {
        if (res.data.Status === true) {
          showMessage(
            "Sloats updated",
            "success",
            "Success!",
            "top",
            "top-right",
            0
          );
        } else {
          showMessage(
            res.data.Error,
            "danger",
            "Error!",
            "top",
            "top-right",
            0
          );
        }
      })
      .catch((err) => err);
  };

  return (
    <div className="content-body">
      {data.id ? (
        <div className="container-fluid">
          <EditTopComponent
            BackButtonPath={"/products"}
            DeleteButton={(e) => {
              e.preventDefault();
              confirmAlert({
                customUI: ({ onClose }) => {
                  return (
                    <div
                      className="custom-ui"
                      style={{
                        borderRadius: 8,
                        border: "solid",
                        padding: 70,
                        borderWidth: 0.5,
                      }}
                    >
                      <h1>Are you sure?</h1>
                      <p>You want to delete ?</p>
                      <button
                        onClick={onClose}
                        className="btn btn-primary"
                        style={{ marginRight: 10 }}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={() => {
                          let res = ManageProducts(e, data, "delete", "id=" + id);
                          res
                            .then((res) => {
                              if (res.data.Status === true) {
                                showMessage(
                                  "Delete success",
                                  "success",
                                  "Success!",
                                  "top",
                                  "top-right"
                                );
                                window.location.replace("/products");
                              } else {
                                showMessage(
                                  res.data.Error,
                                  "danger",
                                  "Failed!",
                                  "top",
                                  "top-right"
                                );
                              }
                            })
                            .catch((err) => {
                              showMessage(
                                "Something went wrong",
                                "danger",
                                "Error!",
                                "top",
                                "top-right"
                              );
                            });
                        }}
                        className="btn btn-primary"
                      >
                        Delete
                      </button>
                    </div>
                  );
                },
              });
            }}
            AddButtonName={"Add Product"}
            AddButtonPath={"/addproducts"}
            CancelButton={(e) => {
              e.preventDefault();
              setEdit(false);
            }}
            EditButton={(e) => {
              e.preventDefault();
              setEdit(true);
            }}
            Edit={Edit}
          />
          {Edit ? (
            <ProductEditForm
              data={data}
              setData={setData}
              setEdit={setEdit}
              getData={getData}
              setErrors={setErrors}
              catData={catData}
            />
          ) : (
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <ProductImageGallery
                        data={data}
                        setData={setData}
                        setEdit={setEdit}
                      />
                      <div className="col-xl-9 col-lg-6 col-md-6 col-xxl-7 col-sm-12">
                        <ProductDetailsCard data={data} />
                        
                        <ProductVariantsSection
                          data={data}
                          getData={getData}
                        />

                        <p className="text-content mt-3">
                          {data.description && data.description}
                        </p>

                        <ProductSlotsSection
                          data={data}
                          setData={setData}
                          sloats={sloats}
                          setSloats={setSloats}
                          handleSloatRemove={handleSloatRemove}
                          handleSloatUpdate={handleSloatUpdate}
                        />

                        <ProductMenusSection
                          data={data}
                          tagList={tagList}
                          remainingList={remainingList}
                          getData={getData}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="container-fluid">
          <div className="page-titles">
            <NoDataComponent data={"Product"} />
          </div>
        </div>
      )}
    </div>
  );
}

function ProductID() {
  const headers = "Product Details";

  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default ProductID;
